import {useState, forwardRef} from 'react';
import TextField from '@mui/material/TextField';
import {AssignTree, type TreeSelection} from './AssignTree';
import {TagList} from './TagList';
import {type NavigationTreePlan} from 'client';
import {FormControl, Menu} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

interface DropdownTreeProps {
  data: NavigationTreePlan;
  setSelected: (selection: TreeSelection) => void;
  selected: TreeSelection;
  disabled?: boolean;
  dataTestId?: string;
}

export const DropdownTreeSelect = ({data, setSelected, selected, disabled, dataTestId}: DropdownTreeProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    if (disabled) {
      return;
    }
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const MyCustomInput = forwardRef(() => (
    <TagList data={data} open={open} selected={selected} setSelected={setSelected} disabled={disabled} />
  ));

  return (
    <FormControl fullWidth>
      <TextField
        disabled={disabled}
        label={'Site / Cage'}
        onClick={handleClick}
        slotProps={{
          input: {
            sx: {minHeight: 54, paddingRight: 1},
            endAdornment: <ArrowDropDownIcon />,
            inputComponent: () => <MyCustomInput />,
          },
          inputLabel: {shrink: true},
        }}
        data-testid={dataTestId}
      />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            sx: {
              maxHeight: 600,
              width: 320,
              backgroundColor: (theme) => theme.palette.background.default,
            },
          },
        }}
      >
        <AssignTree
          planTreeNavigation={data}
          selected={selected}
          setSelected={setSelected}
          dataTestIdPrefix={dataTestId}
        />
      </Menu>
    </FormControl>
  );
};
